import { getModuleBg, getModuleButtonBg } from "../../../config/modules.config";

export const getServiceTabs = (modules, userRoles = [], hasAccess) =>
  modules
    .filter((m) => m.showInDashboard !== false)
    .map((m) => {
      const Icon = m.icon;

      const ownsModule = m.role ? hasAccess(m.role) : true;

      const roleContent = ownsModule
        ? null
        : userRoles.map((r) => m.accessContent?.[r]).find(Boolean);

      const content = roleContent || {
        label: m.label,
        description: m.description,
        buttonText: m.buttonText,
        route: m.path,
      };

      return {
        id: m.id,
        role: m.role,
        route: content.route || m.path,
        title: content.label,
        description: content.description,
        buttonText: content.buttonText,
        icon: <Icon fontSize="inherit" />,
        statusDot: m.statusDot,
        bgColor: getModuleBg(m),
        buttonColor: getModuleButtonBg(m),
      };
    })
    .reverse();
